var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlant = function SvgPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 18.8c-.4-2.6.1-5 1-6.5.1-.1.3-.1.3 0C6.1 14.1 8 15 9.9 15c3.7 0 7.9-2.5 8-11.6 0-.2-.2-.3-.3-.2C13 6.9 13.9 4 9 4 6.6 4 4.3 5.8 4 8.5c0 .2.2.3.3.1 1.9-1.7 5.3-3.5 9.4-.6.2.1 0 .4-.2.4-6-2-12.4 2.7-12.5 10.5 0 0 .1.1.2.1h2.4c.1 0 .2-.1.2-.2z"
  })));
};
export default SvgPlant;